import { Injectable } from "@angular/core";
import { BaseFacade } from "@webapp/core/abstracts/services/base-facade.service";
import { Kpi, KpiDTO } from "../models/kpis.models";
import { KpisApiService } from "./kpis-api.service";
import { KpisState } from "./kpis-state.service";

@Injectable({
  providedIn: "any",
})

// TODO: fix models
export class KpisFacade extends BaseFacade<Kpi, KpiDTO, KpisState, KpisApiService> {
  constructor(state: KpisState, api: KpisApiService) {
    super(state, api);
  }
}
